/* Cosa Nostraa - inline the quantity stepper with the buy buttons.
 *
 * Dawn renders the quantity selector as its own block, a SIBLING of the
 * <product-form>, bound to the form only by the HTML form="" attribute. That
 * is why quantity sits on its own full-width row above Add to Cart.
 *
 * This moves the real node into .product-form__buttons as the first child and
 * tags that container with .cn-buy-row, which assets/cn-buy-row.css then lays
 * out as a single row. The form="" attribute stays valid and now simply
 * points at the form that contains it.
 *
 * Why a DOM move rather than editing Liquid: the quantity markup lives in
 * sections/main-product.liquid (100KB+ of bespoke code) and is also used by
 * quick-add. Moving the node touches neither, and the layout only applies
 * where this script runs, so product cards and the cart page are untouched.
 */
(function () {
  'use strict';

  function relayout() {
    var forms = document.querySelectorAll('product-form');
    Array.prototype.forEach.call(forms, function (form) {
      var sectionId = form.getAttribute('data-section-id');
      if (!sectionId) return;

      // quick-add modals and the sticky bar must not be touched
      if (form.closest('product-modal') || form.closest('cart-drawer')) return;

      var buttons = form.querySelector('.product-form__buttons');
      if (!buttons) return;

      var qty = document.getElementById('Quantity-Form-' + sectionId);
      if (!qty) {
        // no quantity block on this template - just style the buttons
        buttons.classList.add('cn-buy-row');
        return;
      }

      if (qty.parentNode !== buttons) {
        buttons.insertBefore(qty, buttons.firstChild);
      }
      buttons.classList.add('cn-buy-row');
    });
  }

  function start() {
    relayout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // theme editor + section re-render
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('shopify:section:select', start);
})();
